import React, { useState, useCallback, useEffect, useRef } from "react"
import classNames from "classnames"

import { ReactComponent as SearchSVG } from "assets/Icon/Search.svg"
import { ReactComponent as HistorySVG } from "assets/Icon/History.svg"
import { ReactComponent as ChevronRightSVG } from "assets/Icon/Chevron Right.svg"
import { ReactComponent as ProblemSVG } from "assets/Icon/Problem.svg"
import { ReactComponent as KeySVG } from "assets/Icon/Key.svg"

import "./SearchField.sass"
import { useSelector } from "react-redux"

const EXAMPLE_NUMBER = "5N3ZA0NE6AN906847"

const hiddenSubmitStyle = {
  position: "absolute",
  pointerEvents: "none",
  opacity: 0,
}

function PersonalHistory({ onClick }) {
  const { entries } = useSelector((state) => state.search)
  const { entries: garage } = useSelector((state) => state.garage)

  function handleClick(e, entry) {
    e.preventDefault()

    onClick && onClick()

    window.location.pathname = `/search/${entry.vin}/`
  }

  return (
    <div className="PersonalHistory">
      {entries.map((entry) => (
        <div className="entry" onClick={(e) => handleClick(e, entry)}>
          <span className="make_and_model">{entry.make_and_model}</span>
          <span className="vin">
            {entry.vin}
            {entry.is_anomalous || entry.is_stolen ? (
              <>
                {" "}
                <ProblemSVG className="danger" />
              </>
            ) : (
              (entry.is_warning ||
                entry.tehnicni_kriticna ||
                entry.tehnicni_error) && (
                <>
                  {" "}
                  <ProblemSVG className="warning" />
                </>
              )
            )}
            {garage.find(
              (g) => g.vin.toUpperCase() === entry.vin.toUpperCase(),
            ) && (
              <>
                {" "}
                <KeySVG className="safe" />
              </>
            )}
          </span>
          <ChevronRightSVG className="chevron" />
        </div>
      ))}
    </div>
  )
}

const SearchField = ({ searchValue = "", isTall }) => {
  const inputRef = useRef(null)

  const [vin, setVin] = useState(searchValue)
  const [width, setWidth] = useState(window.innerWidth)
  const isMobile = width < 640
  const isNarrow = width < 1200

  const handleVinChange = useCallback((e) => {
    const { value } = e.currentTarget
    setVin((value || "").replace(/\s/g, ""))
  }, [])

  useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    if (window.location.pathname === "/" && !isMobile) inputRef.current.focus()
  }, [isMobile])

  const handleSubmit = (e) => {
    e.preventDefault()

    const isValid = !!vin && vin.length > 4

    if (!isValid) {
      return
      // return alert("VIN mora vsebovati 17 znakov")
    }

    window.location.href = "/search/" + vin.toUpperCase() + "/"
  }

  const { entries: searchEntries } = useSelector((state) => state.search)
  const [showHistory, setShowHistory] = useState(false)

  const handleHistoryClick = (e) => {
    e.preventDefault()

    setShowHistory(!showHistory)
  }

  // function handleFocusClick(e) {
  //   setShowHistory(true)
  // }

  const searchFieldClassName = classNames({
    SearchField: true,
    isHistoryVisible: showHistory,
    isTall,
  })

  return (
    <>
      <form className={searchFieldClassName} onSubmit={handleSubmit}>
        <div className="input-with-icon">
          <input
            id="vin"
            type="text"
            maxLength={17}
            placeholder={
              isNarrow
                ? "Vnesite VIN številko"
                : `VIN številka (npr. ${EXAMPLE_NUMBER})`
            }
            onChange={handleVinChange}
            // onClick={handleFocusClick}
            value={vin}
            ref={inputRef}
          />

          {searchEntries && searchEntries.length > 0 && (
            <a
              className="search-history"
              href="/search-history/"
              onClick={handleHistoryClick}
            >
              <HistorySVG />
            </a>
          )}
        </div>

        <a href="/search" className="submit" onClick={handleSubmit}>
          <span>Prikaži</span>
          <SearchSVG />
        </a>

        <input type="submit" onClick={handleSubmit} style={hiddenSubmitStyle} />
      </form>
      {showHistory && <PersonalHistory onClick={() => setShowHistory(false)} />}
    </>
  )
}

export default SearchField
